import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from "react-router";
import Projects from './components/pages/Projects/Projects';
import About from './components/pages/About/About';
import Navbar from './components/Navbar/Navbar';
import { pageInfo } from './types/pageInfo';
import Contact from './components/pages/Contact/Contact';

const pages: pageInfo[] = [
  {name: 'Projets', link: '/'},
  {name: 'À propos', link: '/à-propos'},
  {name: 'Contact', link: '/contact'},
];

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <BrowserRouter>
    <header className="App-header">
      <Navbar pages={pages}/>
    </header>
    <main>
      <Routes>
        <Route path="/" element={<Projects />} />
        <Route path="/à-propos" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </main>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
